import ConfigService from '../services/ConfigService';

/**
 * Convert diamonds to USD with 2 decimal places precision following the platform's calculation:
 * 1. Calculate gross earnings based on coin value
 * 2. Apply platform fee
 * 3. Apply streamer's percentage
 * 
 * @param {number} diamonds - Number of diamonds to convert
 * @returns {number} USD value with 2 decimal places
 */
export const diamondsToUsd = (diamonds) => {
  if (!diamonds || isNaN(diamonds)) return 0;

  const config = ConfigService.getInstance();
  const platformFee = config.getPlatformFees() / 100; // Convert to decimal
  const coinValueUsd = config.getCoinValueUsd();
  
  const grossEarnings = diamonds * coinValueUsd;
  const netEarnings = grossEarnings * (1 - platformFee);
  const streamerEarnings = netEarnings * (config.getWithdrawPercent() / 100);
  
  return Number(streamerEarnings.toFixed(2));
};

/**
 * Format a number as USD currency string
 * @param {number} amount - Amount to format
 * @returns {string} Formatted USD string (e.g., "$123.45")
 */
export const formatUsd = (amount) => {
  if (!amount || isNaN(amount)) return "$0.00";
  return `$${amount.toFixed(2)}`;
};

export const convertDiamondsToUsdFormat = (diamonds) => {
  return formatUsd(diamondsToUsd(diamonds));
};

